import React from 'react';
import { Link, withRouter } from "react-router-dom"
import {Input,Form,FormGroup,Label} from "reactstrap";
const Columns = (columnas,filters,ramal,report) => {
		let columns = [
			{
				id: 'number',
				name: report=='unidades' ? 'Unidad':'Operador',
				selector: row => {
					return report=='unidades' ? row.number:row.full_name
				},
				sortable: true,
				minWidth: report=='unidades' ? '100px':'200px',
			},
		];
		if(columnas){
			columnas.map(col=>{
				columns.push(
					{
						id: `${col.id_geo}Cant`,
						name: col.alias ? col.alias:col.name,
						conditionalCellStyles: [
							{
								when: row => {
									const hasCantidad = row[col.position + 'a']?.cantidad

									return hasCantidad
								},
								style: {
									backgroundColor: "#ffc333",
								},
							},
						],
						cell: row => {
							return (
								<div className={``}>
								{row[col.position + 'a']?.cantidad ?
									<Link 
										to="/salidas" 										
										onClick={
											() => localStorage.setItem("config", JSON.stringify({
												unit_id:report=='unidades'? row.id:null,
												operator_id:report=='operadores'? row.id:null,
												initDate:filters.initDate,
												endDate:filters.endDate,
												ramal_id:filters.ramal_id,
												ramal:ramal,
												operator: report=='operadores'? {id:row.id, name:row.name}:null,
												unit: report=='unidades'? row:null
											}))
										}
									>
										<div style={{color: row?.isTotal ? '' : '', fontWeight: row?.isTotal ? 'bold' : ''}}>
											{row[col.position + 'a']?.cantidad ?? 0} Veces
										</div>
										<div style={{color: row?.isTotal ? '' : '', fontWeight: row?.isTotal ? 'bold' : ''}}>
											({row[col.position + 'a']?.minutos ?? 0} min)
										</div>
									</Link>
									:
									<>
										<div>
											{row[col.position + 'a']?.cantidad ?? 0} Veces
										</div>
										<div>
											({row[col.position + 'a']?.minutos ?? 0} min)
										</div>
									</>	
								}
								</div>
							) 
						},
						sortable: false
					},
				)
			})

			columns.push({
				id: `totals`,
				name: 'Total',
				conditionalCellStyles: [
					{
						when: row => true,
						style: {
							backgroundColor: "#d4edda",
						},
					},
				],
				cell: row => {
					return (
						<div className={``}>
							<div style={{fontWeight: row?.cantidad ? 'bold' : '' }}>
								{row?.cantidad ?? 0} Veces
							</div>
							<div style={{fontWeight: row?.cantidad ? 'bold' : '' }}>
								({row?.minutos ?? 0} min)
							</div>
						</div>
					) 
				},
				sortable: false
			})
		}

	return columns;
}

export default Columns;

//vaneton beicli